export const reloadWithParam = (param: string, value: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set(param, value);
    window.location.assign(url.toString());
};
